// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Taxonomies
import {
  salesChannelCore,
  salesChannelListing
} from '../../../taxonomies/salesChannel';

// This component
export default function SalesChannel() {
  // Taxonomies
  const { endpoint } = salesChannelCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = salesChannelListing();

  // Listing
  const {
    page,
    setPage,
    pageSize,
    setPageSize,
    activeFilters,
    saveActiveFilters,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'sales-channel',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        page,
        setPage,
        pageSize,
        setPageSize,
        activeFilters,
        saveActiveFilters,
        // page: null,
        // setPage: (page) => {},
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Sales Channel"
        buttonNewLabel="New Sales Channel"
        buttonNewUrl="/sales-channel/new"
        exportAction={false}
      />
    </ListingContext.Provider>
  );
}
